import { List, Datagrid, TextField, DateField, EmailField, BooleanField } from 'react-admin';

export const LegacyUserList = () => (
  <List title='Legacy Users' exporter={false}>
    <Datagrid rowClick='show' bulkActionButtons={false}>
      <TextField source='id' sortable={false} />
      <TextField source='externalId' sortable={false} label='External Id' />
      <TextField source='firstName' sortable={false} label='First Name' />
      <TextField source='middleName' sortable={false} label='Middle Name' />
      <TextField source='lastName' sortable={false} label='Last Name' />
      <EmailField source='email' sortable={false} label='Email' />
      <TextField source='loginId' sortable={false} label='Login Id' />
      <TextField source='role' sortable={false} />
      <BooleanField source='isMigrated' sortable={false} label='Is Migrated' />
      <DateField source='signUpCompletedAt' sortable={false} label='Sign Up Completed At' />
    </Datagrid>
  </List>
);
